export default "__VITE_ASSET__6B26yO7w__"